import { Children, isValidElement, cloneElement } from 'react'
import { SocialLink } from './social-link'
import { SocialWrap } from './style'

const Social = ({ children, space = '15px', size = 'medium', ...props }) => {
  const childProps = {
    color: props.color,
    size,
    shape: props.shape,
    variant: props.variant,
    hover: props.hover,
    space,
    tooltip: props.tooltip,
    tooltip_bg: props.tooltip_bg,
    tooltip_position: props.tooltip_position
  }
  const childrenWithProps = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, { ...childProps })
    }
    return child
  })
  return <SocialWrap {...props}>{childrenWithProps}</SocialWrap>
}

export { SocialLink }
export default Social
